import {Component, Input, Output, EventEmitter} from '@angular/core';
import {CompanyImageResponse, CompanyResponse, UserResponse} from '../../../../@shared/models/response.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {formatTimeYMD} from '../../../../@core/utils/utils.service';

import {
  EditUserProfile
} from '../../../user-profile/components/user-profile-overview/components/edit-user-profile/edit-user-profile';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {EditCompanyProfile} from './components/edit-company-profile/edit-company-profile';
import {EditCompanyImages} from './components/edit-company-images/edit-company-images';
import {CompanyService} from '../../../../@shared/services/company.service';
import {CarouselItem} from '../../../../@shared/components/carouselorini/carouselorini';
import {PaymentService} from '../../../../@shared/services/payment.service';



type EditorConstructor = {
  create(
    sourceElementOrData: string | HTMLElement,
    config?: Record<string, unknown>
  ): Promise<any>;
  EditorWatchdog: any;
};

@Component({
  selector: 'app-company-profile-overview',
  standalone: false,
  templateUrl: './company-profile-overview.html',
  styleUrl: './company-profile-overview.css'
})
export class CompanyProfileOverview {
  @Input() company: CompanyResponse
  @Output() dataChanged = new EventEmitter<void>();
  companyImages: CompanyImageResponse[] = [];
  slides: CarouselItem[] = []
  isUpgrading = false;

  readonly CLUB_PRO_FEE = 2999;

  constructor(private modal: NgbModal,
              private router: Router,
              private companyService: CompanyService,
              private paymentService: PaymentService) {
  }

  ngOnInit() {
    this.getCompanyImages()
  }

  openEditProfileModal() {
    let modalRef = this.modal.open(EditCompanyProfile, {size: 'lg', centered: true});
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result === 'deleted') {
        // Company was deleted, navigate to user profile
        this.router.navigate(['/user-profile']);
      } else if (result) {
        // Company was updated, emit data changed
        this.dataChanged.emit();
      }
    }).catch(() => {
      // Modal dismissed, do nothing
    });
  }

  openEditImagesModal() {
    let modalRef = this.modal.open(EditCompanyImages, {size: 'lg', centered: true});
    modalRef.componentInstance.company = this.company;
    modalRef.result.then(() => {
      // Always refresh images after modal closes (deletions or uploads may have occurred)
      this.getCompanyImages();
    }).catch(() => {
      // Modal dismissed, still refresh in case deletions occurred
      this.getCompanyImages();
    });
  }

  // Cast the build to the expected constructor type
  public Editor: EditorConstructor = ClassicEditor as unknown as EditorConstructor;

  onReady(editor: any) {
    console.log('CKEditor ready', editor);
  }

  getCompanyImages() {
    this.companyService.getCompanyImages({}).subscribe((res) => {
      this.companyImages = res;
      // Clear slides array before repopulating to avoid duplicates
      this.slides = [];
      for(let image of this.companyImages) {
        this.slides.push({imageUrl: image.image_url})
      }
    })
  }


  /**
   * Check if company is a riding club that can upgrade to pro
   */
  canUpgradeToPro(): boolean {
    return this.company?.company_type === 'riding_club' && !this.company?.subscription_active;
  }

  /**
   * Check if company has active pro subscription
   */
  hasProSubscription(): boolean {
    return this.company?.subscription_active === true;
  }

  /**
   * Start the club pro subscription checkout process
   */
  upgradeToClubPro() {
    if (this.isUpgrading) return;
    this.isUpgrading = true;

    const successUrl = window.location.href + '?subscription=success';
    const cancelUrl = window.location.href + '?subscription=cancelled';

    this.paymentService.createClubProCheckout(this.company.company_id, successUrl, cancelUrl).subscribe({
      next: (response) => {
        // Redirect to Stripe checkout
        window.location.href = response.checkout_url;
      },
      error: (error) => {
        console.error('Failed to create club pro checkout:', error);
        this.isUpgrading = false;
      }
    });
  }

  protected readonly formatTimeYMD = formatTimeYMD;
  protected readonly Date = Date;
}
